export const goToCopilot = "tXs64d";
export default {goToCopilot};